import { useNavigate } from "react-router-dom";
import { useTheme } from '@/contexts/ThemeContext';

export default function NotFound() {
  const navigate = useNavigate();
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === 'dark';

  const textPrimary = isDark ? 'text-[#F5F5F7]' : 'text-neutral-900';
  const textSecondary = isDark ? 'text-[#A1A1A6]' : 'text-neutral-400';
  const pageBg = isDark ? 'bg-[#0F0F10]' : 'bg-neutral-50';
  const iconBg = isDark ? 'bg-[#F5F5F7]' : 'bg-neutral-900';
  const iconText = isDark ? 'text-[#0F0F10]' : 'text-white';
  const buttonBg = isDark ? 'bg-[#F5F5F7]' : 'bg-neutral-900';
  const buttonText = isDark ? 'text-[#0F0F10]' : 'text-white';

  return (
    <div className={`min-h-screen ${pageBg} flex flex-col items-center justify-center px-6 transition-colors duration-500 lg:ml-[260px]`}>
      <div className={`w-16 h-16 rounded-full ${iconBg} flex items-center justify-center mb-5 transition-colors duration-500`}>
        <span className={`text-2xl font-bold ${iconText} transition-colors duration-500`}>404</span>
      </div>
      <h1 className={`text-lg font-bold ${textPrimary} mb-2 transition-colors duration-500`}>Page Not Found</h1>
      <p className={`text-sm ${textSecondary} text-center mb-6 max-w-xs transition-colors duration-500`}>
        The page you are looking for does not exist or has been moved.
      </p>
      <button
        onClick={() => navigate("/")}
        className={`${buttonBg} ${buttonText} px-6 py-3 rounded-xl text-sm font-semibold transition-all active:scale-[0.98] cursor-pointer whitespace-nowrap transition-colors duration-500`}
      >
        Back to Home
      </button>
    </div>
  );
}